export default __webpack_public_path__ + "static/media/youtube-footer-icon.5b1f8526.svg";